import React, { useEffect, useState } from "react";
import { Divider } from "antd";
import Dashboard from "./Dashboard/GSADashboard";
import "./index.scss";
import Fundraisers from "./Fundraisers/Fundraisers";
import FundraisersHeroListing from "../GSA/FundraisersHeroListing/FundraisersHeroListing";
import Participants from "./Participants/Participants";
import GSAListing from "../SuperAdmin";
import { sessionServices } from "../../Utils/SessionServices";
import TeamsListing from "./Teams/Teams";

export default function HomePage() {
  const [activeKey, setActiveKey] = useState();
  const key = "activeKey";
  const [role, setRole] = useState("");

  useEffect(() => {
    sessionServices
      .getSessionStorageItem(key)
      .then((value) => {
        setActiveKey(parseInt(value));
      })
      .catch(() => setActiveKey(1));
  }, [key]);

  const fetchRole = async () => {
    const currentRole = await sessionServices?.getSessionStorageItem("role");
    setRole(currentRole);
  };
  useEffect(() => {
    fetchRole();
  }, []);

  
  const handleTabClick = async (value) => {
    setActiveKey(value);
    try {
      await sessionServices.setSessionStorageItem("activeKey", value);
    } catch (error) {
      console.error(error);
    }
  };

  // LISTING OUT ALL THE TABS AND THEIR ACCESS ARRAY
  const tabPanes = [
    {
      name: "Dashboard",
      activeKey: 1,
      userAccess: ["GSA", "ADMIN", "HERO"],
    },
    {
      name: "Fundraisers",
      activeKey: 2,
      userAccess: ["GSA", "ADMIN", "HERO"],
    },
    {
      name: "GSA",
      activeKey: 3,
      userAccess: ["ADMIN"],
    },
    {
      name: "Fundraiser Hero",
      activeKey: 4,
      userAccess: ["GSA", "ADMIN"],
    },
    {
      name: "Teams",
      activeKey: 5,
      userAccess: ["GSA", "ADMIN", "HERO"],
    },
    {
      name: "Participants",
      activeKey: 6,
      userAccess: ["GSA", "ADMIN", "HERO"],
    },
  ];

  // RETURNS THE ASSOCIATED COMPONENT BASED ON ACTIVE KEY
  function RenderTabPage(activeKey) {
    switch (activeKey) {
      case 1:
        return (
          <div className="tabPage">
            <Dashboard />
          </div>
        );
      case 2:
        return (
          <div className="tabPage">
            <Fundraisers />
          </div>
        );
      case 3:
        return (
          <div className="tabPage">
            <GSAListing />
          </div>
        );
      case 4:
        return (
          <div className="tabPage">
            <FundraisersHeroListing />
          </div>
        );
      case 5:
        return (
          <div className="tabPage">
            <>
              <TeamsListing />
            </>
          </div>
        );
      case 6:
        return (
          <div className="tabPage">
            <Participants />
          </div>
        );
      default:
        break;
    }
  }

  return (
    <div className="tabContainer">
      <div className="tabPane">
        {tabPanes.map((tab, i) => {
          // RENDERING THE TABS ACCORDING TO USER USING EACH TAB'S USERACCESS ARRAY
          if (tab?.userAccess.includes(role)) {
            return (
              <>
                <div
                  className={`individual-tabPane ${tab?.activeKey === activeKey ? `selected` : ``
                    }`}
                  onClick={() => handleTabClick(tab?.activeKey)}
                >
                  {tab?.name}
                </div>
                {i !== tabPanes?.length - 1 ? (
                  <Divider className="tab-divider" type="vertical" />
                ) : (
                  <></>
                )}
              </>
            );
          }
        })}
      </div>
      {RenderTabPage(activeKey)}
    </div>
  );
}
